import { createContext } from 'react';
import { LoadingContext as TLoadingContext } from './types';

export const LoadingContext = createContext<TLoadingContext>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  null as any,
);
